var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisablePermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48972 16.9927C8.6209 17.9671 9.42791 18.7304 10.41 18.7755C11.2363 18.8135 12.0758 18.8333 13.0002 18.8333C13.9246 18.8333 14.764 18.8135 15.5903 18.7755C16.5724 18.7304 17.3794 17.9671 17.5106 16.9927C17.5962 16.3569 17.6668 15.7053 17.6668 15.0417C17.6668 14.3781 17.5962 13.7264 17.5106 13.0906C17.3794 12.1163 16.5724 11.353 15.5903 11.3078C14.764 11.2698 13.9246 11.25 13.0002 11.25C12.0758 11.25 11.2363 11.2698 10.41 11.3078C9.42791 11.353 8.6209 12.1163 8.48972 13.0906C8.40411 13.7264 8.3335 14.3781 8.3335 15.0417C8.3335 15.7053 8.40411 16.3569 8.48972 16.9927Z",
    stroke: "#65686F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 11.25V9.79166C10.375 8.34191 11.5503 7.16666 13 7.16666C14.4498 7.16666 15.625 8.34191 15.625 9.79166V11.25",
    stroke: "#65686F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 15.0358V15.0508",
    stroke: "#65686F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.0358V15.0508",
    stroke: "#65686F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 15.0358V15.0508",
    stroke: "#65686F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisablePermission);
export default __webpack_public_path__ + "static/media/disable-permission.46212c5af0d0aaee74ae5050a1918417.svg";
export { ForwardRef as ReactComponent };